export default {
  title: 'Detalles del pedido',
  order_again: 'Volver a pedir',
};
